export class LogbogBeskaeftigelseGetModel {
    beskaeftigelseId : string;
    ansoegningId : string;

    constructor(beskaeftigelseId : string, ansoegningId : string) {
        this.beskaeftigelseId = beskaeftigelseId;
        this.ansoegningId = ansoegningId;
    }
}
